angular.module('core')
    .component('ibanFormat', {
        bindings: {
            iban: '<',
            short: '<?',
            copyButton: '<?'
        },
        template: '<span style="white-space: nowrap;">' +
            '<span ng-if="$ctrl.country != null" style="color: saddlebrown; font-weight: bold; font-size: smaller;">{{$ctrl.country}}</span>&nbsp;' +
            '<span ng-if="$ctrl.short !== true && $ctrl.ibanFormat != null">{{ $ctrl.ibanFormat }}</span>' +
            '<span ng-if="$ctrl.short === true && $ctrl.ibanFormatShort != null" uib-tooltip="{{$ctrl.ibanFormat}}">{{ $ctrl.ibanFormatShort }}</span>' +
            '<copy-to-clipboard ng-if="$ctrl.copyButton === true" value="$ctrl.ibanFormat"></copy-to-clipboard>' +
            '</span>',
        controller: function () {
            let defaultCountryCode = 'PL';
            let separator = ' ';
            let NON_ALPHA = /[^a-zA-Z]/g;
            let NON_ALPHANUM = /[^a-zA-Z0-9]/g;
            let EVERY_FOUR_CHARS = /(.{4})(?!$)/g;

            this.$onChanges = () => {
                if (this.iban == null) {
                    this.ibanFormat = null;
                    this.ibanFormatShort = null;
                    this.country = null;
                    return;
                }
                let ibanFormat = this.iban.replace(NON_ALPHANUM, '').toUpperCase();
                if (ibanFormat.length > 2 && ibanFormat.slice(0, 2).match(NON_ALPHA)) {
                    this.country = defaultCountryCode
                } else {
                    this.country = ibanFormat.slice(0, 2);
                    ibanFormat = ibanFormat.slice(2);
                }
                if (ibanFormat.length > 2) {
                    let firstPart = ibanFormat.slice(0, 2);
                    ibanFormat = firstPart + separator + ibanFormat.slice(2).replace(EVERY_FOUR_CHARS, "$1" + separator);
                }

                this.ibanFormatShort = ibanFormat.slice(0, 2) + "..." + ibanFormat.slice(-4)
                this.ibanFormat = ibanFormat;
            }
        }
    })
    .directive('ibanInput', function () {
        return {
            restrict: 'A',
            require: 'ngModel',
            scope: {
                ngModel: '='
            },
            link: function (scope, elem, attrs, ctrl) {
                let defaultCountryCode = 'PL';
                let separator = ' ';
                let NON_ALPHA = /[^a-zA-Z]/g;
                let NON_ALPHANUM = /[^a-zA-Z0-9]/g;
                let EVERY_FOUR_CHARS = /(.{4})(?!$)/g;

                function toView(iban) {
                    if (iban == null) {
                        return null;
                    }
                    let country;
                    let ibanFormat = iban.replace(NON_ALPHANUM, '').toUpperCase();
                    if (ibanFormat.length > 2 && ibanFormat.slice(0, 2).match(NON_ALPHA)) {
                        country = defaultCountryCode
                    }
                    if (ibanFormat.length > 2) {
                        let firstPart = ibanFormat.slice(0, 2);
                        ibanFormat = firstPart + separator + ibanFormat.slice(2).replace(EVERY_FOUR_CHARS, "$1" + separator);
                    }
                    if (country != null) {
                        return country + " " + ibanFormat;
                    } else {
                        return ibanFormat;
                    }
                }

                function toModel(view) {
                    if (view == null) {
                        return null;
                    }
                    return view.replace(NON_ALPHANUM, '').toUpperCase();
                }

                ctrl.$validators.iban = (modelValue) => {
                    if (ctrl.$isEmpty(modelValue)) {
                        return true;
                    }
                    let valid = IBAN.isValid(modelValue);
                    if (!valid) {
                        // console.error('IBAN is not valid', modelValue)
                    }
                    return valid;
                }
                ctrl.$parsers.push(view => {
                    let model = toModel(view);
                    let viewAfterModelChanged = toView(model);
                    if (view !== viewAfterModelChanged) {
                        ctrl.$setViewValue(viewAfterModelChanged);
                        ctrl.$render();
                    }
                    model = toModel(viewAfterModelChanged);
                    return model;
                });

                ctrl.$formatters.push(model => {
                    let view = toView(model);
                    //update model if no country code in db/model
                    let modelAfterViewChanged = toModel(view);
                    if (model !== modelAfterViewChanged) {
                        ctrl.$modelValue = modelAfterViewChanged;
                        scope.ngModel = modelAfterViewChanged;
                        ctrl.$setTouched();
                    }
                    return view;
                });
            }
        };
    })
